import React, { useEffect, useState } from 'react';
import { BOT_NAMES } from './botNames';
import { PLAYER } from '../playerData';
import { MAX_PLAYERS } from './config';
import { ASSETS } from '../assetManifest';

function Matchmaking({ gameInterface, onMatchReady, onFinishGame }) {
  const [matchmaking, setMatchmaking] = useState(true);
  const [startingMatch, setStartingMatch] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [matchReadyTriggered, setMatchReadyTriggered] = useState(false);
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (gameInterface) {
        setUsersList(Object.values(gameInterface.users));
      }
    }, 10);

    return () => clearInterval(interval);
  }, [gameInterface]);
  
  useEffect(() => {
    const availableNames = [...BOT_NAMES];
    let botCount = 0;
    
    const addBot = () => {
      if (botCount >= MAX_PLAYERS - 1) return;
      
      const nameIndex = Math.floor(Math.random() * availableNames.length);
      const botName = availableNames.splice(nameIndex, 1)[0];
      const botId = `bot-${botCount}`;
      
      gameInterface.users[botId] = {
        sid: botId,
        name: botName,
        stats: { ...PLAYER.stats },
        is_bot: true
      };
      
      botCount++;
      
      if (Object.keys(gameInterface.users).length >= MAX_PLAYERS && !matchReadyTriggered) {
        setMatchmaking(false);
        setStartingMatch(true);
        setMatchReadyTriggered(true);
        setTimeout(() => {
          onMatchReady();
        }, 1200);
      }
    };
    
    const timeouts = [];
    for (let i = 0; i < MAX_PLAYERS - 1; i++) {
      const randomDelay = 500 + Math.random() * 3000;
      timeouts.push(setTimeout(addBot, randomDelay));
    }
    
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [gameInterface, onMatchReady, matchReadyTriggered]);

  return (
    <div className="w-full h-full relative overflow-hidden">
      <img 
        className="w-full h-full absolute left-0 top-0" 
        src={ASSETS.backgrounds.matchmakingBg.path} 
        alt="Matchmaking Background" 
      />
      
      <div className="w-[346px] h-[756px] left-[22px] top-[44px] absolute">
        <div 
          className="w-24 h-9 left-0 top-[720px] absolute"
          onClick={onFinishGame}
        >
          <div className="w-24 h-9 left-0 top-0 absolute bg-[#ff495e] rounded-[5px] shadow-[inset_0px_-6px_2px_0px_rgba(189,17,20,1.00)] border-2 border-black" />
          <div className="w-24 h-[33px] left-0 top-0 absolute text-center text-white text-[22px] font-extrabold font-['Asap'] capitalize leading-[30px]">Leave</div>
        </div>
        
        <div className="w-[334px] h-[46px] left-0 top-[647px] absolute text-center text-white text-[28px] font-black font-['Asap'] [text-shadow:_0px_2px_2px_rgb(0_0_0_/_0.84)]">
          Players : {usersList.length}/{MAX_PLAYERS}
        </div>
        
        <div className="w-[346px] h-[547px] left-0 top-[87px] absolute">
          <div className="w-[346px] h-[547px] left-0 top-0 absolute bg-white/60 rounded-[9px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] border-2 border-black" />
          
          {usersList.map((user, index) => (
            <div 
              key={user.sid}
              className="w-[314px] h-12 left-[16px] absolute"
              style={{ top: `${19 + index * 65}px` }}
            >
              <div className="w-[314px] h-12 left-0 top-0 absolute bg-[#dbdbdb]/75 rounded-[5px] border-2 border-black" />
              <div className="w-[297px] h-12 left-[6px] top-0 absolute text-center text-[#0c0846] text-2xl font-black font-['Asap'] leading-[45px] [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
                {user.name}
              </div>
            </div>
          ))}
        </div>
        
        {startingMatch && (
          <div className="w-[346px] h-[78px] left-0 top-0 absolute text-center text-white text-[32px] font-black font-['Asap'] leading-[74px] [text-shadow:_0px_2px_2px_rgb(0_0_0_/_1.00)]">
            Starting...
          </div>
        )}
        
        {matchmaking && !startingMatch && (
          <div className="w-[346px] h-[78px] left-0 top-0 absolute text-center text-white text-[32px] font-black font-['Asap'] leading-[74px] [text-shadow:_0px_2px_2px_rgb(0_0_0_/_1.00)]">
            Finding players...
          </div>
        )}
      </div>
    </div>
  );
}

export default Matchmaking;
